import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the table sessions report view.
 * @extends JetView
 */
export default class tableSessionsReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Current user parameter
        var vthis = this; // Reference to the current instance

        return {
            rows: [
                {
                    id: 'preloader', // Preloader ID
                    cols: [
                        {
                            view: 'datatable', // Data table view
                            id: 'datatable', // Data table ID
                            footer: false, // Disable footer
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'ActionTittle', // Column ID
                                    header: '', // Column header
                                    width: 70, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Acción'), // Tooltip text
                                    template: function (obj) {
                                        // Template function for rendering
                                        if (obj.State == 'A') {
                                            return "<span class='webix_icon wxi-close torefuse'></span>"; // Icon for active state
                                        } else {
                                            return ''; // No icon for inactive state
                                        }
                                    },
                                },
                                {
                                    id: 'SessionId', // Column ID
                                    header: _('ID Sesión'), // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'PlayerId', // Column ID
                                    header: _('ID Usuario'), // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'StartTime', // Column ID
                                    header: _('Fecha Creación'), // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'EndTime', // Column ID
                                    header: _('Fecha Modificación'), // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ProviderName', // Column ID
                                    header: _('Proveedor'), // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'State', // Column ID
                                    header: _('Estado'), // Column header
                                    options: [
                                        // Options for dropdown
                                        { id: 'A', value: _('Activo') }, // Active state
                                        { id: 'I', value: _('Inactivo') }, // Inactive state
                                    ],
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                torefuse: function (euv, id) {
                                    // Click event for the refuse action
                                    var vvthis = this; // Reference to the current instance
                                    webix.confirm({
                                        // Confirmation dialog
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Inactivar Sesión?'), // Confirmation message
                                        ok: _('Aceptar'), // OK button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            // Callback for confirmation
                                            if (action === true) {
                                                var item = vvthis.getItem(id); // Get the clicked item
                                                webix
                                                    .ajax() // AJAX request
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Client/CancelSessions2', // API endpoint
                                                        '{"SessionId":' +
                                                            item.SessionId +
                                                            ',"Token":"' +
                                                            item.Token +
                                                            '","ProviderId":"' +
                                                            item.ProviderId +
                                                            '"}', // Request body
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(
                                                                    'Error! ', // Error message
                                                                );
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var resp = JSON.parse(
                                                                    text, // Parse response
                                                                );
                                                                if (
                                                                    resp.HasError // Check for errors in response
                                                                ) {
                                                                    webix.message({
                                                                        title: _('¡Error!'),
                                                                        type: 'alert-error',
                                                                        text: _(
                                                                            resp.AlertMessage, // Display error message
                                                                        ),
                                                                    });
                                                                } else {
                                                                    item.State = 'I'; // Update item state to inactive
                                                                    webix.message(
                                                                        _(
                                                                            'Sesión Inactivada', // Success message
                                                                        ),
                                                                    );
                                                                    vthis
                                                                        .$$(
                                                                            'datatable', // Refresh the data table
                                                                        )
                                                                        .refresh();
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead setting
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch setting
                            ready: function () {
                                // Ready event for the data table
                                if (!this.count()) {
                                    // Check if there are no data
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay box
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') + // No data message
                                            '</div>',
                                    );
                                }
                            },
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The data table instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the data table instance
        const cur_user = this.getParam('user', true); // Current user parameter
        var url = devConfig.geturlApi() + 'null/Report/getSessions2?PlayerId=' + cur_user + '&'; // API URL for fetching sessions
        var filter = ''; // Filter string

        this.on(this.app, 'sessionReport:filter', (filterData) => {
            // Event listener for filtering
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Filter query string
            for (var i = 0; i < object.length; i++) {
                // Iterate over filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date; // Handle single date
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append start date
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // End date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append end date
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&PlayerId=' + cur_user; // Append current user ID
            grid.clearAll(); // Clear existing data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter string
        });
    }
}

// FILE DOCUMENTED
